/**
 * CMS 公开 API 封装（替换 fetchMock 为原生 fetch）
 * 接口基础路径: /public-api
 * 所有接口均为 GET 请求，无需认证
 * 统一响应格式: { code: 200, message: 'success', data: ... }
 */
// 配置项
const CMS_CONFIG = {
  baseUrl: 'https://www.xinghanmaterials.com',
  // 接口基础路径
  apiPrefix: '/public-api',
  // 请求超时时间（毫秒）
  timeout: 10000,
  // 通用请求头
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
};

/**
 * 通用请求工具函数
 * @param {string} path 接口路径（如 /contact-us/headquarters）
 * @param {Object} params GET 请求参数
 * @returns {Promise<Object>} 接口返回的 data 字段
 * @throws {Error} 请求失败时抛出错误（含状态码、错误信息）
 */
async function request(path, params = {}) {
  // 拼接完整 URL
  const fullUrl = new URL(`${CMS_CONFIG.baseUrl}${CMS_CONFIG.apiPrefix}${path}`);
  
  // 拼接 GET 参数（过滤 null/undefined/- 空值）
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '-') {
      fullUrl.searchParams.append(key, value);
    }
  });

  // 超时控制器
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), CMS_CONFIG.timeout);

  try {
    const response = await fetch(fullUrl.toString(), {
      method: 'GET',
      headers: CMS_CONFIG.headers,
      credentials: 'same-origin', // 跨域时可改为 'include'（需后端配置 CORS）
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    // 解析响应 JSON
    const result = await response.json();

    // 处理 HTTP 状态码
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${result.message || '请求失败'}`);
    }

    // 处理业务状态码
    if (result.code !== 200) {
      throw new Error(`业务错误 [${result.code}]: ${result.message || '操作失败'}`);
    }

    return result.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error(`请求超时（${CMS_CONFIG.timeout/1000}秒）: ${path}`);
    }
    throw new Error(`${path} 请求失败: ${error.message}`);
  }
}

export default request